import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import { Colors } from '../../../../themes';
import { Svgs } from '../../../../assets/svg';
import { ContinueLinkingItem } from './Types';
import ContinueLinkingLogo from './ContinueLinkingLogo';

const ContinueLinkingRow: React.FC<{
  item: ContinueLinkingItem;
  onClick: (item: ContinueLinkingItem) => void;
}> = ({ item, onClick }) => {
  return (
    <ButtonBase
      onClick={() => onClick(item)}
      sx={{
        'alignItems': 'center',
        'borderRadius': '7px',
        'display': 'flex',
        'justifyContent': 'flex-start',
        'px': 1,
        'py': 1.5,
        'position': 'relative',
        'textAlign': 'left',
        'width': '100%',
        '&::before': {
          backgroundColor: 'transparent',
          borderRadius: '7px',
          bottom: -1,
          content: '""',
          left: 0,
          position: 'absolute',
          right: 0,
          top: -1,
          transition: 'background-color 120ms ease',
          zIndex: 0,
        },
        '& > *': {
          position: 'relative',
          zIndex: 1,
        },
        '&:hover': {
          zIndex: 1,
        },
        '&:hover::before': {
          backgroundColor: Colors.disabledLight,
        },
      }}>
      <Stack
        alignItems='center'
        direction='row'
        spacing={1.5}
        sx={{ justifyContent: 'space-between', minWidth: 0, width: '100%' }}>
        <ContinueLinkingLogo institution={item} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography color='secondary' variant='p16'>
            {item.accountName}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexShrink: 0, ml: 1.5 }}>
          <Svgs.IconArrowRight className='svg-img' style={{ height: 25, width: 25 }} />
        </Box>
      </Stack>
    </ButtonBase>
  );
};

export default ContinueLinkingRow;
